import React, { useState, useEffect } from 'react'
import { createStructuredSelector } from 'reselect'
import { branch, renderComponent } from 'recompose'
import classNames from 'classnames'

import { withTranslate } from '@i18n/utils'

import { CardSection } from '@components/CardSection'
import { VehicleTabs } from '@components/VehicleTabs'
import ErrorMessage from '@components/ErrorMessage'
import Button from '@components/Button'
import VehicleFormModal from '@components/VehicleFormModal'
import LoginSignUpContainer from '@components/LoginSignUpContainer'
import useBookingValidation from 'shared/hooks/useBookingValidation'
import { useSendGTAGEvent } from 'analytics/utils'

import { selectVehicle, enableCard } from '@booking/actions'
import { CARDS } from '@booking/reducers'
import { vehiclesSelector, selectedSeasonTicketSelector } from '@booking/selectors'
import { userSelector } from 'auth/selectors'

import styles from './styles.module.scss'

const $VehicleSelection = ({
    userVehicles,
    onNext,
    setVehicle,
    translate: t,
    noLimit = false,
    selectVehicle,
    vehicles,
    rate,
    currentItemIndex,
}) => {
    const [selectedVehicles, setSelectedVehicles] = useState([])
    const { updateValidation } = useBookingValidation()
    const sendGTAGEvent = useSendGTAGEvent()
    const isMultipleVehicle = rate && rate.isMultipleVehicle
    const numberOfVehicles = isMultipleVehicle ? rate.numberOfVehicles : 1

    const selectedVehicleLabel = selectedVehicles.length > 0 && selectedVehicles[0].tag

    useEffect(() => {
        updateValidation({
            selectedVehiclesError: false,
            isSameTicketInBasketError: false,
        })
    }, [vehicles, currentItemIndex, isMultipleVehicle, rate])

    useEffect(() => {
        updateValidation({
            selectedVehiclesError: false,
        })

        if (selectedVehicles && selectedVehicles.length > 0) enableCard([CARDS.PAY_FOR_PARKING])
    }, [selectedVehicles, rate])

    const onNextStep = () => {
        onNext()
        setVehicle({ ...selectedVehicles, displayValue: selectedVehicleLabel })
        selectVehicle(selectedVehicles)
        sendGTAGEvent('select_vehicle', {})
    }

    return (
        <CardSection className="p-6">
            <h3 className={classNames('text-uppercase', 'font-weight-bold', styles.dateLabel)}>
                <T>booking.purchase.vehicle.label</T>
            </h3>
            {selectedVehicles.length === 0 && (isMultipleVehicle || noLimit) && (
                <ErrorMessage messages={[t('purchase.flow.vehicles.add.vehicle.warning')]} type="text" />
            )}
            <div className="d-flex flex-column">
                <VehicleTabs
                    setSelectedVehicles={setSelectedVehicles}
                    vehicles={selectedVehicles}
                    userVehicles={userVehicles}
                    maxVehicles={numberOfVehicles}
                    isVehiclesListOpen
                    canAddPlate={false}
                />

                <VehicleFormModal />
                <div className={classNames('row', styles.nextButtonContainer)}>
                    <Button
                        btnStyle="primary"
                        onClick={onNextStep}
                        disabled={selectedVehicles.length < 1}
                        className={styles.nextButton}>
                        <T>subscription.purchase.label.next</T>
                    </Button>
                </div>
            </div>
        </CardSection>
    )
}

const VehicleSelection = compose(
    connect(
        createStructuredSelector({
            userVehicles: vehiclesSelector,
            user: userSelector,
            selectedSeasonTicket: selectedSeasonTicketSelector,
            vehicles: vehiclesSelector,
        }),
        { selectVehicle, enableCard }
    ),
    withTranslate,
    branch(({ user }) => !user, renderComponent(LoginSignUpContainer), renderComponent($VehicleSelection))
)(VehicleSelection)

export default VehicleSelection
